export const MODEL_OPTIONS = [
  { value: "gpt-4.1", label: "GPT-4.1" },
  { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
  { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" },
  { value: "o3-mini", label: "O3 Mini" },
  { value: "o3", label: "O3" },
  { value: "o3-pro", label: "O3 Pro" },
  { value: "gpt-5", label: "GPT-5" },
  { value: "gpt-5-mini", label: "GPT-5 Mini" },
  { value: "gpt-5-nano", label: "GPT-5 Nano" },
  { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
  { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
  { value: "gemini-3-pro-preview", label: "Gemini 3 Pro" },
  // { value: "claude-3-5-haiku-latest", label: "Claude 3.5 Haiku" },
  // { value: "claude-sonnet-4-20250514", label: "Claude Sonnet 4 " },
  // { value: "claude-sonnet-4-5-20250929", label: "Claude Sonnet 4.5" },
  { value: "sonar", label: "Sonar" },
  { value: "sonar-pro", label: "Sonar Pro" },
  { value: "sonar-deep-research", label: "Sonar Deep Research" },
  { value: "grok-4-1-fast-reasoning", label: "Grok 4.1 Fast Reasoning" },
  { value: "grok-4-1-fast-non-reasoning", label: "Grok 4.1 Fast Non-Reasoning" }
] as const;

export type TModelType = (typeof MODEL_OPTIONS)[number]["value"];
